<script lang="ts" setup>
import StorageService from '../../../runtime/services/StorageService';

const { $log } = useLogging();
const { $alert } = useAlerts();
const { $t } = useLocalization();

const props = withDefaults(defineProps<{
    scope?: string;
    folder: number | null;
}>(), {
    scope: 'public'
});

const emit = defineEmits<{
    (e: 'reload'): void;
}>();

const form = ref<any>(Form.create({ folderName: '' }));
const modalRef = ref<any>(null);
const inputRef = ref<any>(null);

const createFolder = async (): Promise<void> =>
{
    try
    {
        form.value.wait();

        await StorageService.createFolder({
            scope: props.scope,
            parentId: props.folder,
            folderName: form.value.folderName
        });

        $alert.success($t('[[[Katalog został utworzony]]]'));
        modalRef.value.hide();
        form.value.folderName = '';
        emit('reload');
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message),
            422: (ex: any) => form.value.$errors.record(ex.data.errors)
        });
    }
    finally
    {
        form.value.continue();
    }
};

const showModal = (): void =>
{
    form.value.folderName = '';
    modalRef.value.show();
};

defineExpose({
    showModal
});
</script>

<template>
    <IdeoModal
        ref="modalRef"
        :title="$t('[[[Utwórz katalog]]]')"
        modal-class="filemanager-modal"
        backdrop-class="filemanager-backdrop"
        hide-footer
        @shown="inputRef.focus()"
    >
        <form @submit.prevent="createFolder" @keydown="form.$errors.clear($event.target.name)">
            <IdeoFormGroup :label="$t('[[[Nazwa katalogu]]]')" label-for="folder-name" :invalid-feedback="form.$errors.first('folderName')" :state="form.$errors.state('folderName')" label-cols="3">
                <IdeoFormInput id="folder-name" ref="inputRef" v-model="form.folderName" type="text" name="folderName" />
            </IdeoFormGroup>

            <div class="text-end">
                <button type="button" class="btn btn-light" @click.prevent.prevent="modalRef.hide()">
                    <i class="fa fa-ban" />
                    {{ $t('[[[Anuluj]]]') }}
                </button>

                <button type="submit" class="btn btn-success" :disabled="!form.active()">
                    <i v-if="form.$loading" class="fas fa-spinner fa-spin" />
                    <i v-if="!form.$loading" class="fas fa-check" />
                    {{ $t('[[[Zapisz]]]') }}
                </button>
            </div>
        </form>
    </IdeoModal>
</template>
